<img class="avatar" [src]=image *ngIf="image" [ngClass]="{'bordered': this.bordered}">
<div class="letters {{calculatedBackground}}" [ngClass]="{'bordered': this.bordered}" *ngIf="!image">
  {{firstLetter}}{{secondLetter}}
</div>
